// #817 — the running release, for the staff footer.
//
// /version.json is a static file the deploy script (deploy/bin/bcid-deploy.sh,
// step 9) writes into the docroot alongside the bundle: the CalVer release
// (`2026.10.1`) on a production promote, `<env>-<shortsha>` otherwise. It is
// NOT an API route, so this is a plain same-origin fetch rather than apiFetch:
// no /api/v1 prefix, no bearer token, nothing for the CSP's connect-src 'self'
// to refuse.
//
// cache: 'no-store' is what keeps the footer honest. nginx sends this file with
// no Cache-Control (only index.html is marked no-store), so without it a browser
// may heuristically reuse last release's copy and name a version that is no
// longer running.
//
// Every failure answers null and the footer renders nothing: a missing file
// (a box whose deploy script predates #817), a network error, or nginx's SPA
// fallback answering 200 with index.html, which fails to parse as JSON.

// What a deploy writes, with headroom; anything else is not ours to display.
const VERSION_SHAPE = /^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/;

export async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store', credentials: 'same-origin' });
    if (!res.ok) return null;
    const body: unknown = await res.json();
    const version = (body as { version?: unknown } | null)?.version;
    return typeof version === 'string' && VERSION_SHAPE.test(version) ? version : null;
  } catch {
    return null;
  }
}
